import { useEffect, useState } from "react";

// The type system's big size, --type-big in app.css: clamp(32px, 4vw, 48px).
// CSS vw counts the scrollbar, as window.innerWidth does, so the two agree.
export function bigTypePx() {
  if (typeof window === "undefined") return 48;
  return Math.min(48, Math.max(32, window.innerWidth * 0.04));
}

// The catalog title wheel's row height. 41px was the row for a 35px title, so
// the row is the big size x 41/35: the same formula as the height of
// .slot-filter__outer--stacked in app.css, which clips the wheel to one row.
// SlotFilter steps the stack by this many pixels, so the two must match.
export function useTitleRowPx() {
  const [px, setPx] = useState(() => (bigTypePx() * 41) / 35);
  useEffect(() => {
    const onResize = () => setPx((bigTypePx() * 41) / 35);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return px;
}
